import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchDenestImpcMapping = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdImpcDenestMappingDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.get(serviceURL, payload);
};
